
import type { IconProps } from 'src/types/icons';

const PendingReviewIcon = (props: IconProps) => (
  <svg {...props} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="7.2124" cy="7.02441" r="6" stroke="#FF5D5D" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="1 3" />
  </svg>
);

export default PendingReviewIcon;
